module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};



// WEBPACK FOOTER //
// C:/Dropbox/www/amcharts4dev/node_modules/core-js/modules/_a-function.js